import { useEffect } from 'react';

import { useAppStore } from 'src/hooks/useAppStore';
import { fetchUserData } from 'src/services/apiRequests/UserService';
import { mixpanelObject } from 'src/utils/analytics';
import { userDataPropertySetter } from 'src/utils/analytics/mixpanel/mixpanelHelper';
import {
  getLocalStorage,
  setSessionStorage
} from 'src/utils/browserStorageHandler';
import {
  USER_CONSENTS,
  USER_TOKEN
} from 'src/utils/constants/localStorageConstants';

import { LoggedInContainer } from './styles';

const LoggedIn = () => {
  const { translations, usersData, setUsersData } = useAppStore();
  const newSubscriptionStrings = translations.subscription;
  const loginText =
    newSubscriptionStrings.Subscription_Bottomsheet_Already_Loggedin_Text ?? '';
  useEffect(() => {
    (async () => {
      if (getLocalStorage(USER_TOKEN)) {
        const userData = await fetchUserData();
        if (userData?.consents) {
          setSessionStorage(USER_CONSENTS, userData.consents);
        }
        setUsersData({ ...userData });
        userDataPropertySetter(mixpanelObject, userData);
      }
    })();
  }, []);

  if (!usersData?.mobile && !usersData?.email) {
    return null;
  }
  const userInfo = usersData?.mobile || usersData?.email;

  return (
    <LoggedInContainer data-test-id="subs-login-info">{`${loginText} ${userInfo}`}</LoggedInContainer>
  );
};
export default LoggedIn;
